import MapController from './mapController'

export const mapController = new MapController()
